import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Translations
    hero_banner: 'Stop refreshing TLS, VFS Global & BLS websites! Subscribe now and get instant alerts when appointments open.',
    hero_banner_fr: 'Arrêtez de rafraîchir les sites TLS, VFS Global et BLS ! Abonnez-vous et recevez des alertes instantanées.',
    
    // Security Section
    security_title: 'Your Security is Our Priority',
    security_subtitle: 'We take your privacy and security seriously',
    security_no_phishing: 'No Phishing - Ever',
    security_no_phishing_desc: 'We never send phishing SMS or emails. All our notifications contain plain text alerts only - no suspicious links, no payment requests.',
    security_no_links: 'No Links in Messages',
    security_no_links_desc: 'Our SMS and email alerts contain only appointment information in plain text. We never include clickable links or ask for personal data.',
    security_not_tls: 'Independent Service',
    security_not_tls_desc: 'We are NOT affiliated with TLS Contact, VFS Global, or BLS International. We do not book appointments for you. We simply notify you when slots become available so YOU can book directly on the official websites.',
    security_cancel: 'Cancel Anytime',
    security_cancel_desc: 'Your €7.99/month subscription can be cancelled at any time. No hidden fees, no long-term commitment.',
    
    // FAQ
    faq_title: 'Frequently Asked Questions',
    faq_1_q: 'How does VisaAlerts work?',
    faq_1_a: 'We monitor TLS Contact, VFS Global, and BLS International appointment availability 24/7. When new slots open, we immediately send you an SMS and/or email notification so you can book before others.',
    faq_2_q: 'Do you book appointments for me?',
    faq_2_a: 'No. We only send notifications. You must book your appointment directly on the official TLS Contact, VFS Global, or BLS websites. We are an independent alert service.',
    faq_3_q: 'Is my payment information secure?',
    faq_3_a: 'Yes. All payments are processed securely through Stripe. We never store your card details on our servers.',
    faq_4_q: 'Can I cancel my subscription?',
    faq_4_a: 'Yes, you can cancel anytime. Your subscription will remain active until the end of your billing period.',
    faq_5_q: 'Why don\'t you include links in your messages?',
    faq_5_a: 'For your security. We never include links to avoid any possibility of phishing. Always go directly to the official visa center websites to book.',
    
    // Dashboard
    dashboard_security_notice: 'We never send links or payment requests via SMS/Email. All our alerts contain plain text only.',
    dashboard_subscribe_benefits: 'Subscribe to unlock:',
    dashboard_benefit_1: 'Real-time SMS & Email alerts',
    dashboard_benefit_2: 'TLS, VFS Global & BLS monitoring',
    dashboard_benefit_3: 'Multiple countries visa tracking',
    dashboard_hidden_date: 'Subscribe to see dates',
    
    // Navigation
    nav_home: 'Home',
    nav_pricing: 'Pricing',
    nav_contact: 'Contact',
    nav_dashboard: 'Dashboard',
    nav_profile: 'My Account',
    nav_login: 'Login',
    nav_register: 'Get Started',
    nav_logout: 'Logout',
    
    // Hero
    hero_title: 'Never Miss a Visa Appointment Again',
    hero_subtitle: 'Get instant SMS & email alerts when new visa slots open at TLS Contact, VFS Global, and BLS centers in Tunis, Sfax, Rabat, Casablanca, Cairo, London and Dublin. Stop refreshing, start booking!',
    hero_cta: 'Start Getting Alerts',
    hero_trusted: 'Trusted by travelers from Tunisia, Morocco, UK, Algeria & more',
    
    // Features
    features_title: 'How It Works',
    features_subtitle: 'Three simple steps to never miss a visa appointment',
    feature_1_title: 'Select Your Country',
    feature_1_desc: 'Choose your residence country and visa destination (France, Germany, Spain, Italy, Switzerland & more)',
    feature_2_title: 'Choose Alert Type',
    feature_2_desc: 'Get notified via SMS, email, or both when slots open',
    feature_3_title: 'Book Instantly',
    feature_3_desc: 'Receive real-time alerts and book before slots disappear',
    
    // Pricing
    pricing_title: 'Simple, Transparent Pricing',
    pricing_subtitle: 'One plan. Full access. Cancel anytime.',
    pricing_monthly: 'Monthly',
    pricing_price: '7.99',
    pricing_old_price: '10',
    pricing_currency: '€',
    pricing_period: '/month',
    pricing_price_tnd: '12',
    pricing_old_price_tnd: '25',
    pricing_promo_badge_tnd: 'TUNISIA OFFER -52%',
    pricing_tnd_exclusive: 'Tunisia Exclusive',
    pricing_promo_badge: 'LIMITED OFFER -20%',
    pricing_promo_text: 'Exclusive launch price!',
    pricing_feature_1: 'Unlimited SMS & Email Alerts',
    pricing_feature_2: 'Real-time Appointment Monitoring',
    pricing_feature_3: 'TLS, VFS Global & BLS Tracking',
    pricing_feature_4: 'Instant Notifications',
    pricing_feature_5: 'Cancel Anytime',
    pricing_guarantee: '100% Money-Back Guarantee',
    pricing_guarantee_desc: 'No alerts in 30 days? Full refund, no questions asked.',
    pricing_cta: 'Get Started - Save 20%',
    pricing_buy_stripe: 'Buy with Stripe',
    pricing_buy_dhmad: 'Buy with DHMAD',
    pricing_dhmad_title: 'In Tunisia? No credit card, no problem 🇹🇳',
    pricing_dhmad_desc: 'Pay securely via {dhmad} — Tunisia\'s trusted escrow payment service. Your money is protected until your subscription is confirmed.',
    pricing_dhmad_cta: 'Pay with DHMAD.tn',

    // Urgency & Conversion
    missed_appointments: '{count} appointment alerts were sent this week!',
    missed_appointments_for: 'To subscribers in {from}',
    dont_miss_next: "Don't Miss the Next One",

    // Popup
    popup_just_now: 'Just Now',
    popup_title: 'New Appointment Alert!',
    popup_slots: '{count} slots available for {country} visa at {center}!',
    popup_subscribe_text: 'Subscribe now to receive instant alerts like this and never miss an appointment!',
    popup_guarantee: '100% Money-Back Guarantee - No alerts in 30 days? Full refund!',
    popup_cancel: 'Cancel anytime • No commitment',
    popup_cta: 'Subscribe Now - Only €7.99/month',
    // Email Preview
    email_preview_badge: 'Email Preview',
    email_preview_title: 'This is What Your Alert Email Looks Like',
    email_preview_subtitle: 'Instant, professional notifications sent directly to your inbox the moment appointments become available.',
    email_preview_cta: 'Get Alerts Like This',
    
    // Risk Free
    risk_free_title: '100% Risk-Free Guarantee',
    risk_free_desc: 'No alerts in 30 days? Full refund, no questions asked!',
    
    // Success Stats
    // Countries
    countries_title: 'Supported Countries',
    countries_from: 'Residence Countries',
    countries_to: 'Destination Countries',
    countries_active: 'Active Monitoring',
    countries_coming: 'Coming Soon',
    
    // Contact
    contact_title: 'Contact Us',
    contact_subtitle: 'Have questions? We\'re here to help.',
    contact_name: 'Your Name',
    contact_email: 'Email Address',
    contact_subject: 'Subject',
    contact_message: 'Message',
    contact_send: 'Send Message',
    contact_success: 'Message sent successfully!',
    
    // Auth
    login_title: 'Welcome Back',
    login_subtitle: 'Sign in to your VisaAlerts account',
    login_email: 'Email',
    login_password: 'Password',
    login_submit: 'Sign In',
    login_register: 'Don\'t have an account?',
    
    register_title: 'Create Account',
    register_subtitle: 'Join VisaAlerts and never miss an appointment',
    register_name: 'Full Name',
    register_email: 'Email',
    register_password: 'Password',
    register_submit: 'Create Account',
    register_login: 'Already have an account?',
    
    // Dashboard
    dashboard_title: 'Dashboard',
    dashboard_subscription: 'Subscription Status',
    dashboard_active: 'Active',
    dashboard_inactive: 'Inactive',
    dashboard_expires: 'Expires',
    dashboard_never_miss_title: 'Never Miss a Visa Appointment!',
    dashboard_never_miss_desc: 'Get instant SMS & email alerts when new visa slots open at TLS Contact centers in {tunis}, {sfax}, {rabat}, {casablanca} and {cairo}. Our system monitors 24/7 so you can book before others!',
    dashboard_feature_realtime: 'Real-time alerts within seconds',
    dashboard_feature_sms_email: 'SMS + Email notifications',
    dashboard_feature_tracking: 'France & Germany visa tracking',
    dashboard_processing: 'Processing...',
    dashboard_subscribe_cta: 'Subscribe Now - €7.99/month',
    dashboard_buy_stripe: 'Buy with Stripe',
    dashboard_buy_dhmad: 'Buy with DHMAD',
    dashboard_cancel_anytime: 'Cancel anytime',
    dashboard_dhmad_no_card: 'No credit card? You can also pay via {dhmad} (Escrow):',
    dashboard_dhmad_pay_link: 'Pay via DHMAD (TND)',
    dashboard_dhmad_note: 'Once your payment is received, your subscription is activated automatically within 24h.',
    dashboard_preferences: 'Notification Preferences',
    dashboard_residence: 'Residence Country',
    dashboard_destination: 'Destination Country',
    dashboard_notification_type: 'Alert Type',
    dashboard_phone: 'Phone Number',
    dashboard_save: 'Save Preferences',
    dashboard_recent: 'Recent Alerts',
    dashboard_subscribe: 'Subscribe to get alerts',
    
    // Profile Page
    profile_title: 'My Account',
    profile_subtitle: 'Manage your profile and subscription',
    personal_info: 'Personal Information',
    name: 'Name',
    email: 'Email',
    residence_country: 'Residence Country',
    member_since: 'Member Since',
    preferences: 'Alert Preferences',
    notification_type: 'Notification Type',
    visa_center: 'Visa Center',
    destination_country: 'Destination Country',
    phone_number: 'Phone Number',
    subscription: 'Subscription',
    active_subscription: 'Active Subscription',
    no_subscription: 'No Active Subscription',
    no_subscription_desc: 'Subscribe to receive instant visa appointment alerts.',
    plan: 'Plan',
    price: 'Price',
    month: 'month',
    expires_on: 'Expires On',
    days_remaining: 'Days Remaining',
    days: 'days',
    cancel_subscription: 'Cancel Subscription',
    cancel_subscription_text: 'To cancel your subscription, please send an email to our customer service team.',
    cancel_subscription_note: 'We will process your cancellation within 24 hours.',
    close: 'Close',
    send_email: 'Send Email',
    alerts_history: 'Alerts History',
    no_alerts_yet: 'No alerts received yet',
    no_alerts_desc: 'You will see your alert history here once you start receiving notifications.',
    visa_appointment: 'Visa Appointment',
    your_stats: 'Your Statistics',
    alerts_received: 'Alerts Received',
    account_status: 'Account Status',
    premium: 'Premium',
    free: 'Free',
    subscribe_now: 'Subscribe Now',
    money_back_guarantee: '30-day money-back guarantee',
    
    // Admin
    admin_title: 'Admin Dashboard',
    admin_users: 'Users',
    admin_subscriptions: 'Subscriptions',
    admin_transactions: 'Transactions',
    admin_notifications: 'Notifications',
    admin_contacts: 'Contact Messages',
    admin_stats: 'Statistics',
    admin_total_users: 'Total Users',
    admin_active_subs: 'Active Subscriptions',
    admin_revenue: 'Revenue',
    admin_alerts_sent: 'Alerts Sent',
    
    // Footer
    footer_company: 'DC LLC',
    footer_location: 'Montana, USA',
    footer_rights: 'All rights reserved',
    footer_privacy: 'Privacy Policy',
    footer_terms: 'Terms of Service',
    
    // Common
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success!',
    email: 'Email',
    sms: 'SMS',
    both: 'Email & SMS',

    // Chat widget
    chat_button_label: 'Chat',
    chat_header_title: 'VisaAlerts Assistant',
    chat_welcome: "Welcome to VisaAlerts! 👋 How can I help you today? You can pay by card via Stripe, or from Tunisia via DHMAD.tn (TND) — pick a topic below or type your question.",
    chat_input_placeholder: 'Type your question...',
    chat_send: 'Send',
    chat_close: 'Close',
    chat_back_to_topics: 'Show topics again',
    chat_fallback: "Sorry, I'm not sure I understood that. Try one of the topics below, or email us at support@visago-alerts.online.",
    chat_topic_payment_tn: '💳 Payment from Tunisia (DHMAD)',
    chat_topic_payment_intl: '💳 Payment by card (Stripe)',
    chat_topic_how_alerts: '🔔 How do I get alerts?',
    chat_topic_refund: '💰 Refund policy',
    chat_topic_what_is: '❓ What is VisaAlerts?',
    chat_answer_payment_tn: "For customers in Tunisia, you can pay via DHMAD.tn (a secure Tunisian escrow service) in Tunisian Dinar (TND) — no international card needed. You'll find a 'Pay via DHMAD' button in your dashboard. Once your payment is confirmed, your subscription activates automatically within 24h.",
    chat_answer_payment_intl: "For all other countries, we accept secure card payment via Stripe. Your card details are encrypted and processed directly by Stripe — we never see or store your card number. Your subscription activates instantly after payment.",
    chat_answer_how_alerts: "Once subscribed, our system checks TLScontact, VFS Global and BLS appointment pages around the clock, for your chosen destination. The moment a new slot opens, we send you an instant SMS and/or email alert (you choose which in your dashboard settings) so you can book before anyone else.",
    chat_answer_refund: "We're confident in our service: if you don't receive a single appointment alert within 30 days of subscribing, you're entitled to a full refund — no questions asked. Just contact our support team.",
    chat_answer_what_is: "VisaAlerts is an independent notification service. We are NOT affiliated with TLScontact, VFS Global or BLS International, and have no special access or agreement with them — we simply monitor their public appointment pages automatically and alert you the instant a slot opens, so you don't have to keep refreshing yourself.",
  },
  fr: {
    // Translations
    hero_banner: 'Arrêtez de rafraîchir les sites TLS, VFS Global et BLS ! Abonnez-vous et recevez des alertes instantanées.',
    hero_banner_fr: 'Arrêtez de rafraîchir les sites TLS, VFS Global et BLS ! Abonnez-vous et recevez des alertes instantanées.',
    
    // Security Section
    security_title: 'Votre Sécurité est Notre Priorité',
    security_subtitle: 'Nous prenons votre vie privée et votre sécurité au sérieux',
    security_no_phishing: 'Pas de Phishing - Jamais',
    security_no_phishing_desc: 'Nous n\'envoyons jamais de SMS ou d\'emails de phishing. Toutes nos notifications contiennent uniquement des alertes en texte simple - pas de liens suspects, pas de demandes de paiement.',
    security_no_links: 'Pas de Liens dans les Messages',
    security_no_links_desc: 'Nos alertes SMS et email contiennent uniquement des informations sur les rendez-vous en texte simple. Nous n\'incluons jamais de liens cliquables.',
    security_not_tls: 'Service Indépendant',
    security_not_tls_desc: 'Nous ne sommes PAS affiliés à TLS Contact, VFS Global ou BLS International. Nous ne réservons pas de rendez-vous pour vous. Nous vous notifions simplement quand des créneaux sont disponibles.',
    security_cancel: 'Annulez à Tout Moment',
    security_cancel_desc: 'Votre abonnement de 7.99€/mois peut être annulé à tout moment. Pas de frais cachés, pas d\'engagement.',
    
    // FAQ
    faq_title: 'Questions Fréquentes',
    faq_1_q: 'Comment fonctionne VisaAlerts ?',
    faq_1_a: 'Nous surveillons la disponibilité des rendez-vous TLS Contact, VFS Global et BLS International 24h/24. Dès qu\'un créneau se libère, nous vous envoyons immédiatement une notification.',
    faq_2_q: 'Réservez-vous des rendez-vous pour moi ?',
    faq_2_a: 'Non. Nous envoyons uniquement des notifications. Vous devez réserver directement sur les sites officiels TLS Contact, VFS Global ou BLS.',
    faq_3_q: 'Mes informations de paiement sont-elles sécurisées ?',
    faq_3_a: 'Oui. Tous les paiements sont traités de manière sécurisée via Stripe. Nous ne stockons jamais vos données bancaires.',
    faq_4_q: 'Puis-je annuler mon abonnement ?',
    faq_4_a: 'Oui, vous pouvez annuler à tout moment. Votre abonnement reste actif jusqu\'à la fin de votre période de facturation.',
    faq_5_q: 'Pourquoi n\'incluez-vous pas de liens ?',
    faq_5_a: 'Pour votre sécurité. Nous n\'incluons jamais de liens pour éviter tout risque de phishing. Allez toujours directement sur les sites officiels des centres de visa.',
    
    // Dashboard
    dashboard_security_notice: 'Nous n\'envoyons jamais de liens ou de demandes de paiement par SMS/Email. Toutes nos alertes sont en texte simple.',
    dashboard_subscribe_benefits: 'Abonnez-vous pour débloquer:',
    dashboard_benefit_1: 'Alertes SMS & Email en temps réel',
    dashboard_benefit_2: 'Surveillance TLS, VFS Global & BLS',
    dashboard_benefit_3: 'Suivi visa multi-pays',
    dashboard_hidden_date: 'Abonnez-vous pour voir les dates',
    
    // Navigation
    nav_home: 'Accueil',
    nav_pricing: 'Tarifs',
    nav_contact: 'Contact',
    nav_dashboard: 'Tableau de bord',
    nav_profile: 'Mon Compte',
    nav_login: 'Connexion',
    nav_register: 'Commencer',
    nav_logout: 'Déconnexion',
    
    // Hero
    hero_title: 'Ne Manquez Plus Jamais un Rendez-vous Visa',
    hero_subtitle: 'Recevez des alertes SMS et email instantanées lorsque de nouveaux créneaux s\'ouvrent aux centres TLS Contact, VFS Global et BLS à Tunis, Sfax, Rabat, Casablanca, Le Caire, Londres et Dublin. Arrêtez de rafraîchir, commencez à réserver !',
    hero_cta: 'Recevoir les Alertes',
    hero_trusted: 'Utilisé par les voyageurs de Tunisie, Maroc, UK, Algérie et plus',
    
    // Features
    features_title: 'Comment Ça Marche',
    features_subtitle: 'Trois étapes simples pour ne jamais manquer un rendez-vous',
    feature_1_title: 'Sélectionnez Votre Pays',
    feature_1_desc: 'Choisissez votre pays de résidence et votre destination visa (France, Allemagne, Espagne, Italie et plus)',
    feature_2_title: 'Choisissez le Type d\'Alerte',
    feature_2_desc: 'Soyez notifié par SMS, email ou les deux quand des créneaux s\'ouvrent',
    feature_3_title: 'Réservez Instantanément',
    feature_3_desc: 'Recevez des alertes en temps réel et réservez avant que les créneaux disparaissent',
    
    // Pricing
    pricing_title: 'Tarification Simple et Transparente',
    pricing_subtitle: 'Un seul forfait. Accès complet. Annulez à tout moment.',
    pricing_monthly: 'Mensuel',
    pricing_price: '7.99',
    pricing_currency: '€',
    pricing_period: '/mois',
    pricing_price_tnd: '12',
    pricing_old_price_tnd: '25',
    pricing_promo_badge_tnd: 'OFFRE TUNISIE -52%',
    pricing_tnd_exclusive: 'Exclusivité Tunisie',
    pricing_promo_badge: 'OFFRE LIMITÉE -20%',
    pricing_promo_text: 'Prix de lancement exclusif!',
    pricing_old_price: '10',
    pricing_feature_1: 'Alertes SMS & Email Illimitées',
    pricing_feature_2: 'Surveillance en Temps Réel',
    pricing_feature_3: 'Suivi TLS, VFS Global & BLS',
    pricing_feature_4: 'Notifications Instantanées',
    pricing_feature_5: 'Annulation à Tout Moment',
    pricing_guarantee: 'Garantie 100% Satisfait ou Remboursé',
    pricing_guarantee_desc: 'Aucune alerte en 30 jours ? Remboursement intégral, sans question.',
    pricing_cta: 'Commencer - Économisez 20%',
    pricing_buy_stripe: 'Payer avec Stripe',
    pricing_buy_dhmad: 'Payer avec DHMAD',
    pricing_dhmad_title: 'En Tunisie ? Pas de carte bancaire, pas de problème 🇹🇳',
    pricing_dhmad_desc: 'Payez en toute sécurité via {dhmad} — le service de paiement séquestre de confiance en Tunisie. Votre argent est protégé jusqu\'à la confirmation de votre abonnement.',
    pricing_dhmad_cta: 'Payer avec DHMAD.tn',
    
    // Urgency & Conversion
    missed_appointments: '{count} alertes de rendez-vous ont été envoyées cette semaine !',
    missed_appointments_for: 'Aux abonnés de {from}',
    dont_miss_next: 'Ne Manquez Pas le Prochain',

    // Popup
    popup_just_now: 'À l\'instant',
    popup_title: 'Nouvelle Alerte de Rendez-vous !',
    popup_slots: '{count} créneaux disponibles pour visa {country} chez {center} !',
    popup_subscribe_text: 'Abonnez-vous maintenant pour recevoir des alertes instantanées comme celle-ci et ne manquez plus jamais un rendez-vous !',
    popup_guarantee: 'Garantie 100% Remboursé - Aucune alerte en 30 jours ? Remboursement intégral !',
    popup_cancel: 'Annulation à tout moment • Sans engagement',
    popup_cta: 'S\'abonner - Seulement 7,99€/mois',
    // Email Preview
    email_preview_badge: 'Aperçu de l\'Email',
    email_preview_title: 'Voici à Quoi Ressemble Votre Email d\'Alerte',
    email_preview_subtitle: 'Notifications professionnelles instantanées envoyées directement dans votre boîte de réception dès que des rendez-vous sont disponibles.',
    email_preview_cta: 'Recevoir des Alertes Comme Celle-ci',
    
    // Risk Free
    risk_free_title: 'Garantie 100% Sans Risque',
    risk_free_desc: 'Aucune alerte en 30 jours ? Remboursement intégral, sans question !',
    
    // Success Stats
    // Countries
    countries_title: 'Pays Supportés',
    countries_from: 'Pays de Résidence',
    countries_to: 'Pays de Destination',
    countries_active: 'Surveillance Active',
    countries_coming: 'Bientôt Disponible',
    
    // Contact
    contact_title: 'Contactez-nous',
    contact_subtitle: 'Des questions? Nous sommes là pour vous aider.',
    contact_name: 'Votre Nom',
    contact_email: 'Adresse Email',
    contact_subject: 'Sujet',
    contact_message: 'Message',
    contact_send: 'Envoyer le Message',
    contact_success: 'Message envoyé avec succès!',
    
    // Auth
    login_title: 'Bon Retour',
    login_subtitle: 'Connectez-vous à votre compte VisaAlerts',
    login_email: 'Email',
    login_password: 'Mot de passe',
    login_submit: 'Se Connecter',
    login_register: 'Pas encore de compte?',
    
    register_title: 'Créer un Compte',
    register_subtitle: 'Rejoignez VisaAlerts et ne manquez plus aucun rendez-vous',
    register_name: 'Nom Complet',
    register_email: 'Email',
    register_password: 'Mot de passe',
    register_submit: 'Créer le Compte',
    register_login: 'Déjà un compte?',
    
    // Dashboard
    dashboard_title: 'Tableau de Bord',
    dashboard_subscription: 'Statut Abonnement',
    dashboard_active: 'Actif',
    dashboard_inactive: 'Inactif',
    dashboard_expires: 'Expire le',
    dashboard_never_miss_title: 'Ne Manquez Plus Jamais un Rendez-vous Visa !',
    dashboard_never_miss_desc: 'Recevez des alertes SMS et e-mail instantanées dès qu\'un créneau se libère dans les centres TLS Contact à {tunis}, {sfax}, {rabat}, {casablanca} et {cairo}. Notre système surveille 24h/24 pour que vous réserviez avant les autres !',
    dashboard_feature_realtime: 'Alertes en temps réel, en quelques secondes',
    dashboard_feature_sms_email: 'Notifications SMS + E-mail',
    dashboard_feature_tracking: 'Suivi des visas France & Allemagne',
    dashboard_processing: 'Traitement...',
    dashboard_subscribe_cta: 'S\'abonner - 7,99€/mois',
    dashboard_buy_stripe: 'Payer avec Stripe',
    dashboard_buy_dhmad: 'Payer avec DHMAD',
    dashboard_cancel_anytime: 'Annulation à tout moment',
    dashboard_dhmad_no_card: 'Pas de carte bancaire ? Vous pouvez aussi payer via {dhmad} (Séquestre) :',
    dashboard_dhmad_pay_link: 'Payer via DHMAD (TND)',
    dashboard_dhmad_note: 'Dès réception du paiement, votre abonnement est activé automatiquement sous 24h.',
    dashboard_preferences: 'Préférences de Notification',
    dashboard_residence: 'Pays de Résidence',
    dashboard_destination: 'Pays de Destination',
    dashboard_notification_type: 'Type d\'Alerte',
    dashboard_phone: 'Numéro de Téléphone',
    dashboard_save: 'Enregistrer',
    dashboard_recent: 'Alertes Récentes',
    dashboard_subscribe: 'Abonnez-vous pour recevoir les alertes',
    
    // Profile Page
    profile_title: 'Mon Compte',
    profile_subtitle: 'Gérez votre profil et abonnement',
    personal_info: 'Informations Personnelles',
    name: 'Nom',
    email: 'Email',
    residence_country: 'Pays de Résidence',
    member_since: 'Membre Depuis',
    preferences: 'Préférences d\'Alerte',
    notification_type: 'Type de Notification',
    visa_center: 'Centre de Visa',
    destination_country: 'Pays de Destination',
    phone_number: 'Numéro de Téléphone',
    subscription: 'Abonnement',
    active_subscription: 'Abonnement Actif',
    no_subscription: 'Aucun Abonnement Actif',
    no_subscription_desc: 'Abonnez-vous pour recevoir des alertes de rendez-vous visa instantanées.',
    plan: 'Forfait',
    price: 'Prix',
    month: 'mois',
    expires_on: 'Expire le',
    days_remaining: 'Jours Restants',
    days: 'jours',
    cancel_subscription: 'Annuler l\'Abonnement',
    cancel_subscription_text: 'Pour annuler votre abonnement, veuillez envoyer un email à notre service client.',
    cancel_subscription_note: 'Nous traiterons votre annulation dans les 24 heures.',
    close: 'Fermer',
    send_email: 'Envoyer Email',
    alerts_history: 'Historique des Alertes',
    no_alerts_yet: 'Aucune alerte reçue',
    no_alerts_desc: 'Vous verrez votre historique d\'alertes ici une fois que vous commencerez à recevoir des notifications.',
    visa_appointment: 'Rendez-vous Visa',
    your_stats: 'Vos Statistiques',
    alerts_received: 'Alertes Reçues',
    account_status: 'Statut du Compte',
    premium: 'Premium',
    free: 'Gratuit',
    subscribe_now: 'S\'abonner Maintenant',
    money_back_guarantee: 'Garantie remboursement 30 jours',
    
    // Admin
    admin_title: 'Administration',
    admin_users: 'Utilisateurs',
    admin_subscriptions: 'Abonnements',
    admin_transactions: 'Transactions',
    admin_notifications: 'Notifications',
    admin_contacts: 'Messages Contact',
    admin_stats: 'Statistiques',
    admin_total_users: 'Total Utilisateurs',
    admin_active_subs: 'Abonnements Actifs',
    admin_revenue: 'Revenus',
    admin_alerts_sent: 'Alertes Envoyées',
    
    // Footer
    footer_company: 'DC LLC',
    footer_location: 'Montana, États-Unis',
    footer_rights: 'Tous droits réservés',
    footer_privacy: 'Politique de Confidentialité',
    footer_terms: 'Conditions d\'Utilisation',
    
    // Common
    loading: 'Chargement...',
    error: 'Une erreur est survenue',
    success: 'Succès!',
    email: 'Email',
    sms: 'SMS',
    both: 'Email & SMS',

    // Chat widget
    chat_button_label: 'Chat',
    chat_header_title: 'Assistant VisaAlerts',
    chat_welcome: "Bienvenue chez VisaAlerts ! 👋 Comment puis-je vous aider ? Vous pouvez payer par carte via Stripe, ou depuis la Tunisie via DHMAD.tn (TND) — choisissez un sujet ci-dessous ou tapez votre question.",
    chat_input_placeholder: 'Tapez votre question...',
    chat_send: 'Envoyer',
    chat_close: 'Fermer',
    chat_back_to_topics: 'Revoir les sujets',
    chat_fallback: "Désolé, je ne suis pas sûr d'avoir compris. Essayez un des sujets ci-dessous, ou écrivez-nous à support@visago-alerts.online.",
    chat_topic_payment_tn: '💳 Paiement depuis la Tunisie (DHMAD)',
    chat_topic_payment_intl: '💳 Paiement par carte (Stripe)',
    chat_topic_how_alerts: '🔔 Comment je reçois les alertes ?',
    chat_topic_refund: '💰 Politique de remboursement',
    chat_topic_what_is: "❓ Qu'est-ce que VisaAlerts ?",
    chat_answer_payment_tn: "Pour les clients en Tunisie, vous pouvez payer via DHMAD.tn (un service d'escrow tunisien sécurisé) en dinars tunisiens (TND) — pas besoin de carte internationale. Vous trouverez un bouton 'Payer via DHMAD' dans votre tableau de bord. Une fois le paiement confirmé, votre abonnement s'active automatiquement sous 24h.",
    chat_answer_payment_intl: "Pour tous les autres pays, nous acceptons le paiement sécurisé par carte via Stripe. Vos données de carte sont chiffrées et traitées directement par Stripe — nous ne voyons ni ne stockons jamais votre numéro de carte. Votre abonnement s'active instantanément après le paiement.",
    chat_answer_how_alerts: "Une fois abonné, notre système vérifie en continu les pages de rendez-vous de TLScontact, VFS Global et BLS pour votre destination choisie. Dès qu'un nouveau créneau s'ouvre, nous vous envoyons instantanément une alerte SMS et/ou email (au choix dans les réglages de votre tableau de bord) pour que vous puissiez réserver avant tout le monde.",
    chat_answer_refund: "Nous sommes confiants dans notre service : si vous ne recevez aucune alerte de rendez-vous dans les 30 jours suivant votre abonnement, vous avez droit à un remboursement intégral, sans justification. Contactez simplement notre équipe support.",
    chat_answer_what_is: "VisaAlerts est un service de notification indépendant. Nous ne sommes PAS affiliés à TLScontact, VFS Global ou BLS International, et n'avons aucun accès ni accord particulier avec eux — nous surveillons simplement leurs pages de rendez-vous publiques automatiquement et vous alertons dès qu'un créneau s'ouvre, pour vous éviter de rafraîchir sans arrêt vous-même.",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('visaalerts_language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('visaalerts_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'fr' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
